import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import type { Conversation, Message } from '../models/conversation.model';

@Injectable({ providedIn: 'root' })
export class MessagingService {
  constructor(private readonly http: HttpClient) {}

  findAll(): Observable<Conversation[]> {
    return this.http.get<Conversation[]>(`${API_BASE_URL}/conversations`);
  }

  getOrCreate(productId: string): Observable<Conversation> {
    return this.http.post<Conversation>(`${API_BASE_URL}/conversations`, { productId });
  }

  listMessages(conversationId: string): Observable<Message[]> {
    return this.http.get<Message[]>(`${API_BASE_URL}/conversations/${conversationId}/messages`);
  }

  sendMessage(conversationId: string, body: string): Observable<Message> {
    return this.http.post<Message>(`${API_BASE_URL}/conversations/${conversationId}/messages`, {
      body,
    });
  }
}
